export const TABS_HEIGHT = 48;
export const HEADER_HEIGHT = 48;
export const THRESHOLD = 50;
export const TABS_WITH_HANDLE_HEIGHT = TABS_HEIGHT + 24;
export const MIN_OFFSET = 100 + HEADER_HEIGHT;
